import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Footer from '../components/common/Footer';
import { useAuthStore } from '../store/authStore';

function PublicLayout() {
  const location = useLocation();
  const { isAuthenticated, user } = useAuthStore();
  const redirectTo = new URLSearchParams(location.search).get('redirect');

  // If authenticated, redirect to appropriate dashboard
  if (isAuthenticated && user) {
    if (redirectTo) {
      return <Navigate to={redirectTo} replace />;
    }
    if (user.role === 'admin') {
      return <Navigate to="/admin" replace />;
    }
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1">
        <Outlet />
      </div>
      {/* <Footer /> */}
    </div>
  );
}

export default PublicLayout;
